import { create } from "zustand";
import { persist } from "zustand/middleware";

interface Dossier {
  id: string;
  nom: string;
  cabinet_id?: string;
  regime_fiscal?: string | null;
  type_comptabilite?: "tresorerie" | "engagement" | null;
}

interface DossierState {
  activeDossier: Dossier | null;
  setActiveDossier: (d: Dossier | null) => void;
  clearDossier: () => void;
}

export const useDossierStore = create<DossierState>()(
  persist(
    (set) => ({
      activeDossier: null,
      setActiveDossier: (d) => set({ activeDossier: d }),
      clearDossier: () => {
        set({ activeDossier: null });
        useDossierStore.persist.clearStorage();
      },
    }),
    {
      name: "woahda-dossier-actif",
      partialize: (state) => ({ activeDossier: state.activeDossier }),
    }
  )
);
